
/** 1 = false, 2 = true */
export enum BOOLEAN_TWO {
    "FALSE" = 1,
    "TRUE" = 2
}